export const comCorporateMenus = (logoUrl) => ({
    type: 'public',
    logoItems: [
        {
            id: 'corporate-logo',
            href: '/en/corporate/',
            url: logoUrl,
            alt: 'Raisin',
        },
    ],
    navItems: [
        {
            id: 'corporate-about-raisin',
            title: 'About Raisin',
            href: '',
            subMenus: {
                main: [
                    {
                        id: 'corporate-about-raisin-about-us',
                        type: 'text',
                        title: 'About us',
                        href: '/en/corporate/about-raisin/',
                    },
                    {
                        id: 'corporate-about-raisin-raisin-bank',
                        type: 'text',
                        title: 'Raisin Bank',
                        href: 'https://www.raisin.bank/en/',
                    },
                ],
            },
        },
        {
            id: 'corporate-partner-with-us',
            title: 'Partner with us',
            href: '',
            subMenus: {
                main: [
                    {
                        id: 'corporate-partner-with-us-become-a-partner-bank',
                        type: 'text',
                        title: 'Become a Partner Bank',
                        href: '/en/corporate/become-a-partner-bank/',
                    },
                    {
                        id: 'corporate-partner-with-us-become-a-distribution-partner',
                        type: 'text',
                        title: 'Become a Distribution Partner',
                        href: '/en/corporate/become-a-distribution-partner/',
                    },
                ],
            },
        },
        {
            id: 'corporate-press',
            title: 'Press',
            href: '/en/corporate/press/',
        },
        {
            id: 'corporate-careers',
            title: 'Careers',
            href: '/en/corporate/careers/',
        },
    ],
    actionItems: [
        {
            id: 'corporate-my-account',
            title: 'My Account',
            href: '/en/login/',
            type: 'login',
        },
    ],
});
//# sourceMappingURL=comCorporateMenus.js.map